import { computed, defineComponent, inject, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { configsProviderKey, type ConfigsNavigationPath } from "../../../infrastructure/configs_provider";
import ConfigsAccessWishdate from "../ConfigsAccessWishdate";
import ConfigsAccessPreviousTenant from "../ConfigsAccessPreviousTenant";
import ConfigsAccessOtoId from "../ConfigsAccessOtoId";
import ConfigsAccessFixIp from "../ConfigsAccessFixIp";
import { useRouter, useRoute } from "vue-router";


const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default defineComponent({
  template: html,
  components: {ConfigsAccessWishdate, ConfigsAccessPreviousTenant, ConfigsAccessOtoId, ConfigsAccessFixIp  },
  emits: {
    next: () => true
  },
  setup() {
    // Injections
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const configsProvider = inject(configsProviderKey);
   
    // variables, computed, refs
    const configsPathes = computed<ConfigsNavigationPath[]>(() => {
      return configsProvider?.configsPathes.value ?? [];
    })
    const showWishdateConfig = computed(() => {
      return configsProvider?.allConfigsTypes.value.includes("AccessDslConfig") 
      || configsProvider?.allConfigsTypes.value.includes("AccessFiberConfig");
    });
    const showPreviousTenantConfig = computed(() => {
      return configsProvider?.allConfigsTypes.value.includes("AccessDslConfig");
    })
    const showOtoIdConfig = computed(() => {
      return configsProvider?.allConfigsTypes.value.includes("AccessFiberConfig");
    })
    const showFixIpConfig = computed(() => {
      return configsProvider?.allConfigsTypes.value.includes("FixipRipeConfig");
    })

    // template refs zu den Kind-Komponenten, um vor dem Weiterschalten deren validate()/isValid abzufragen
    const wishdateRef = ref<any>(null);
    const previousTenantRef = ref<any>(null);
    const otoIdRef = ref<any>(null);
    const fixIpRef = ref<any>(null);
    // während des Klicks auf 'next' läuft validate() ggf. noch auf einen offenen
    // Autosave-Request der Kinder; solange den Button sperren (Doppelklick-Schutz + Feedback)
    const isValidating = ref(false);

    // methods
    const next = async function(){
      const visibleChildren = [
        showWishdateConfig.value ? wishdateRef.value : null,
        showPreviousTenantConfig.value ? previousTenantRef.value : null,
        showOtoIdConfig.value ? otoIdRef.value : null,
        showFixIpConfig.value ? fixIpRef.value : null,
      ].filter((c) => c != null);

      isValidating.value = true;
      let allValid: boolean;
      try {
        const results = await Promise.all(visibleChildren.map((c) => c.validate()));
        allValid = results.every((r) => r);
      } finally {
        isValidating.value = false;
      }
      if (!allValid) {
        return;
      }

      const currentIndex = configsPathes.value.findIndex((p) => p.path == route.path);
      const nextIdx = configsPathes.value[currentIndex + 1]
      if (nextIdx){
        router.push(nextIdx.path);
      } else {
        router.push("/customerdata");
      }
    }

    const back = function(){
      const currentIndex = configsPathes.value.findIndex((p) => p.path == route.path);
      const backIdx = configsPathes.value[currentIndex - 1] 
      if (backIdx){
        router.push(backIdx.path);
      } else {
        router.push("/options");
      }
    }
    

    onMounted(function(){
    })

    return {
      t,
      next,
      back,
      showOtoIdConfig,
      showWishdateConfig,
      showPreviousTenantConfig,
      showFixIpConfig,
      wishdateRef,
      previousTenantRef,
      otoIdRef,
      fixIpRef,
      isValidating,
    };
  },
} as any);
